import { buildProps as o, definePropType as r } from "./index601.js";
const p = o({
  /**
   * @description SVG icon size, size x size
   */
  size: {
    type: r([Number, String])
  },
  /**
   * @description SVG tag's fill attribute
   */
  color: {
    type: String
  }
});
export {
  p as iconProps
};
